import { Icon, IconProps } from '@chakra-ui/react';
import React from 'react';

const GoogleOfficialIcon = (props: IconProps) => (
  <Icon
    height='full'
    viewBox='80 80 355 355'
    width='auto'
    {...props}
  >
    <path
      d='
M103.323387,179.911087
	C128.424240,130.214096 168.080505,98.372276 222.331833,86.522217
	C278.131744,74.333885 328.469971,87.609879 372.623993,123.952148
	C373.375977,124.571106 374.069733,125.260803 374.444794,125.602440
	C357.507996,142.540222 340.714844,159.334351 323.658447,176.391739
	C293.202393,153.270645 259.024841,147.159714 222.375214,161.241623
	C192.944916,172.549622 173.191635,193.961594 162.013138,223.898254
	C142.070724,209.362732 122.697052,194.636902 103.323387,179.911087
z'
      fill='#EA4436'
      opacity='1.000000'
      stroke='none'
    />
    <path
      d='
M162.130127,289.846985
	C169.123184,308.605530 179.766861,324.818542 195.557144,337.365723
	C229.991547,364.727905 279.134979,367.788208 317.907990,345.103271
	C326.533386,351.420929 334.476471,357.714447 342.532074,363.860565
	C352.950348,371.809265 363.458435,379.640228 373.927826,387.521912
	C358.991516,402.462982 341.194305,412.907745 321.634949,420.467194
	C238.598511,452.559570 142.733109,414.890839 103.888535,334.476135
	C123.411247,319.311951 142.770691,304.579468 162.130127,289.846985
z'
      fill='#35A854'
      opacity='1.000000'
      stroke='none'
    />
    <path
      d='
M374.242950,387.337891
	C363.458435,379.640228 352.950348,371.809265 342.532074,363.860565
	C334.476471,357.714447 326.533386,351.420929 318.250244,345.007629
	C333.066437,334.445343 344.266937,321.013916 350.140503,303.468628
	C351.339325,299.887573 352.240631,296.206879 353.447968,291.981018
	C322.003906,291.981018 291.265656,291.981018 260.265564,291.981018
	C260.265564,269.620148 260.265564,247.701935 260.265564,225.391129
	C314.218964,225.391129 368.226959,225.391129 423.591919,225.391129
	C430.969604,286.554077 420.347565,342.035858 374.242950,387.337891
z'
      fill='#4285F4'
      opacity='1.000000'
      stroke='none'
    />
    <path
      d='
M162.102112,289.459290
	C142.770691,304.579468 123.411247,319.311951 103.757477,334.192108
	C79.436691,283.160614 79.369728,231.905411 103.149216,180.243073
	C122.697052,194.636902 142.070724,209.362732 161.793594,224.195618
	C155.541656,245.885345 155.172485,267.474640 162.102112,289.459290
z'
      fill='#FBBC06'
      opacity='1.000000'
      stroke='none'
    />
  </Icon>
);

export default GoogleOfficialIcon;
